














































































































import API from '@/Api';
import {Component, Vue} from 'vue-property-decorator';
@Component
export default class ExitFlowCRPFinance extends Vue {
    public requested: any = [];
    public dialog: boolean = false;
    public selected: any = [];
     public headers: any[] = [
            {
            text: 'Employee Id',
            align: 'left',
            sortable: false,
            value: 'employeeId',
            },
            {
            text: 'Employee Name',
            align: 'left',
            sortable: false,
            value: 'employeeName',
            },
            {
            text: 'Designation',
            align: 'left',
            sortable: false,
            value: 'designation',
            },
            {
            text: 'Applied Date',
            align: 'left',
            sortable: false,
            value: 'appliedDate',
            },
            {
            text: 'Actions',
            align: 'left',
            sortable: false,
            value: 'actions',
            },
        ];

    public mounted() {
        this.load();
    }
    public load() {
        API.Instance
        .get('/api/exit-crp-finance')
        .then((response) => {
            this.requested = response.data;
        });
    }
    public submit(item: any, type: number) {
        API.Instance
            .post('/api/exit-crp-finance', item)
            .then(() => {
                if (item.type === 3) {
                    this.$store.commit('AppStore/SNACK_BAR', {
                    text: `Saved your approval status for ${item.employeeName}!`,
                    show: true,
                });
                } else {
                    this.$store.commit('AppStore/SNACK_BAR', {
                    text: `Submitted your approval status for ${item.employeeName}!`,
                    show: true,
                });
                }
                 }).then(() => {
                     this.load();
                     this.dialog = false;
                 });
    }
     public select(item: any) {
        this.selected = item;
        this.dialog = true;
    }
}
